import React from 'react';

function RenderBioPsychoSocial({ data, id }) {
  return (
    <div className="smart-tag-sec">
      <div className="smart-tag-bdy">
        <div className="qsmart-tag-bdy-rw width100" id={'sectionVal_' + id}>
          {data?.biopsychosocialIntakeData?.map((item, i) => (
            <div key={i} className="cntnt-blk prgrs-vw-blk qsmart-tag-bdy-rw qrecrd-nt-rw left">
              {item[2]?.length > 0 && (
                <div className="assmnt-nt-hdng qfrst-sec-lbl qrecrd-nt-prnt-hdng">{item[1]}</div>
              )}
              {item[2]?.length > 0 &&
                item[2]?.map((subItem, j) => (
                  <div key={j} className="smart-tag-bdy-rw left">
                    <span className="frst-sec-lbl">{subItem?.label}:</span>
                    <span className="left assmnt-nt-val qwidth100 qfrst-sec-val sec-colr">
                      {subItem?.content}
                    </span>
                  </div>
                ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RenderBioPsychoSocial;
